export default __webpack_public_path__ + "static/media/obras5.bb552dd2.webp";